import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Travel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Travel </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      Tourism is a sector focused not only on selling tours and hotel bookings but, 
                      above all, on the idea of spending free time and triggering emotions. 
                      These factors most often decide that we choose a particular place, and 
                      then when we return from our holidays, we either immediately forget about them, 
                      or remember all the attractions well and eagerly share our stories with everyone. 
                      So if our intention is to play on our emotions and awaken the full potential of our 
                      imagination, we should not hesitate to use cutting edge technologies. We can achieve 
                      this with the help of virtual and augmented reality. How is that possible? 
                      Here you can have a look at some interesting ideas.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Planning</b>
                      <br></br>
                      You’ve already decided on the dates, and you have a few locations in mind, 
                      but how do you choose? Via virtual reality. Once you stick on your headset, 
                      you will be able to search or browse through popular locations and experience 
                      them as if you were there. You’ll saunter down the streets of Paris or glide 
                      down Venetian canals. A quick five minutes in each location, and you’ll be 
                      ready to make an educated choice.                    
                    </h6>
                      <h6 className = "mt-4 line-height-h">
                      <b>Booking</b>
                      <br></br>
                      Perhaps one of the most dreaded experiences in travel is booking lodging. 
                      From a great distance, with only internet photos as your ally, choosing a 
                      hotel or resort can be daunting. Still, even with the perfectly manicured 
                      photos plastered on a hotel’s Google page, a certain level of deceptiveness is inevitable.
                      <br></br>
                      You pick your room, based off of a gorgeous photo of a well-made bed in a 
                      room with a large window. When you arrive, it’s easy to see the vantage 
                      point from which the photo was taken. However, when you spin from that spot, 
                      you find the door’s locks have been busted off, you wonder if the filth in the 
                      shower will help or hinder your daily cleaning ritual, and it’s fairly clear 
                      that stain on the floor is older than your sister.
                      <br></br>
                      When you are able to look at a 360 photo or video of this space, however, 
                      it’s more difficult to hide the flaws. So, while you might not enjoy seeing 
                      the stained carpet in the VR booking tour, at least you’re not mislead, and 
                      you will have an opportunity to find a suitable alternative.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Plane Travel</b>
                      <br></br>
                      Both glorious and awful at the same time, flights are the dreaded bookend on many vacations. 
                      While I’ve flown a lot, I can’t say I look forward to the cramped seating and inevitable 
                      long-flight leg cramps or schedule delays.
                      <br></br>
                      Despite the infinite list of reasons flight cons, I find boredom is my biggest challenge. 
                      But, just imagine if on that twenty-two hour flight to Australia, you got to take a couple 
                      of different adventures while you wait.
                      <br></br>
                      Perhaps you go with the newest 3D-VR feature film, or maybe you opt to explore your destination 
                      city before your arrival. Some airlines are already beginning to use this technology as an 
                      on-flight perk, and more will likely join the revolution as VR headsets are are more tangible 
                      entertainment option versus in-seat monitors.
                      <br></br>
                      And VR/AR is just one of the technologies that will transform the future of plane travel.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Navigation</b>
                      <br></br>
                      So, now you’re in a new city. The laws of probability indicate that within your group, 
                      you have the following people:
                      <br></br>
                      a. One who wants to wander without a sense of direction. It’s a bummer you put 
                      her in charge at lunch time, only to find yourself in the one area of the city 
                      where food is somehow elusive.
                      <br></br>
                      b. The old-school map person. Despite always having an interactive and up-to-date 
                      map in the cell phone he always has at the ready, his need to use a six-year-old 
                      paper map has your group somewhere in Omaha (weren’t you in Florida?).
                      <br></br>
                      c. The “I won’t ask for directions” adventurer. There’s only one way to handle this 
                      person — ask for directions, don’t relay the information, and leave him behind.
                      <br></br>
                      Thankfully, augmented reality navigation is coming along nicely. Soon, as you walk 
                      down a new street to explore, you won’t worry about finding a coffee shop or that 
                      hidden gem of a local restaurant. Using a map function on your AR device will show 
                      you everything you want in a user-friendly way.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Attractions</b>
                      <br></br>
                      Whether it’s the Leaning Tower of Pisa or a quaint little museum, the locations 
                      you choose to patronize will become more personalized experiences.
                      <br></br>
                      Some years in the future, you make your way to good ol’ Paris, and you make the 
                      hike toward the Eiffel Tower. Instead of doing the normal tourism standard we 
                      know today (take a photo, take another photo, walk around it, tour it, etc.), 
                      you want to make the whole experience unique to you.
                      <br></br>
                      You download the Paris Adventurer app, and now you pick your experience. You want 
                      30% history, 40% romance, 10% food, and 20% of the cliche tourist moments. The app 
                      does its thing, and suddenly you’re being taken on a tour of Paris which truly speaks 
                      to your desires.
                      <br></br>
                      Instead of getting a historic fact every fifteen feet, as the history buffs might choose, 
                      you only get a cool fact every hour as the walking tour brings you to just a portion of 
                      the area’s romantic highlights. You find and sample some of the best food easily, all 
                      the while, you’re sure you won’t miss the most coveted spots, as you’ve already indicated 
                      you want to see some popular areas.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      When it comes to AR and VR in the tourism space, VR is the sales pitch, and AR is the experience enhancement.
                    </h6>
                    
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Travel templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Travel;



// WEBPACK FOOTER //
// ./src/views/Pages/Travel/Travel.js